export enum ActiveSessionsDisplayedColumns {
  DEVICE = 'device',
  LAST_ACTIVITY_TIME = 'lastActivityTime',
  ACTION = 'action',
}
